import {
  DELIVERY_TOOL_NAMES,
  type DeliveryToolName,
  type DeliveryToolSettings,
} from "@/lib/deliveries/config"

const REQUIRED_DELIVERY_TOOLS: readonly DeliveryToolName[] = [
  "delivery_search_locations",
  "delivery_quote_shipment",
  "delivery_create_shipment",
]

export const DELIVERY_TOOL_SELECTION_HINT = "Enabling any delivery tool also enables location search, quotation, and waybill creation, required for the complete ordering workflow. Price verification and tracking are optional."

export function getDeliveryToolRequirement(name: DeliveryToolName): "Required" | "Optional" {
  return REQUIRED_DELIVERY_TOOLS.includes(name) ? "Required" : "Optional"
}

/** Apply one user toggle; do not change optional choices or unrelated tools. */
export function toggleDeliveryToolSelection(
  enabledTools: readonly string[],
  name: DeliveryToolName,
  enabled: boolean,
): string[] {
  const next = new Set(enabledTools)
  if (enabled) {
    next.add(name)
    for (const required of REQUIRED_DELIVERY_TOOLS) next.add(required)
  } else {
    next.delete(name)
  }
  return [...next]
}

export function updateDeliveryToolSettings(
  settings: DeliveryToolSettings,
  name: DeliveryToolName,
  enabled: boolean,
): DeliveryToolSettings {
  const selected = new Set(toggleDeliveryToolSelection(
    DELIVERY_TOOL_NAMES.filter(tool => settings[tool]), name, enabled,
  ))
  const next = { ...settings }
  for (const tool of DELIVERY_TOOL_NAMES) next[tool] = selected.has(tool)
  return next
}
